import {
  Box,
  Button,
  Paper,
  Tab,
  Tabs,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import TripDetailTab from './componenets/TripDetailTab';
import VehicleAndDriverTab from './componenets/TripVehicleAndDriverTab';
import RouteDetailsTab from './componenets/RouteDetailsTab';
import AlertTab from './componenets/AlertTab';
import TripDetailMap from './componenets/TripDetailMap';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TripProgressBar from './componenets/TripProgressBar';
import MapIcon from '@mui/icons-material/Map';
import ShareIcon from '@mui/icons-material/Share';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import clone from 'packages/novous_web/src/assets/icons/Clone.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import map from 'packages/novous_web/src/assets/icons/Map Stroke.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import LiveFeedModal from '../Reports/components/LiveFeed';
import TripDetailsTiles from './componenets/TripDetailsTiles';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import ShareModal from 'packages/novous_web/src/common/components/ShareTripModal';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
import DateTimeModal from './componenets/DateTimeModel';
import AlertAndWarnings from '../../Dashboard/Alarm/Vehicle-Alerts/components/AlertsData';
import TripAlerts from './componenets/TripAlerts';
import md5 from 'md5';

export default function TripDetails() {
  const isMobile = useMediaQuery('(max-width: 640px)');
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tripId = params.get('tripId');
  const startDateParam = params.get('startDate');
  const endDateParam = params.get('endDate');
  const selectedDurationParam = params.get('selectedDuration');
  const [tripDetailsData, setTripDetailsData] = useState<any>();
  const [tabData, setTabData] = useState<any>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [showMap, setShowMap] = useState(false);
  const [routeInfo, setRouteInfo] = useState<any>(null);
  const [modalDateOpen, setModalDateOpen] = useState(false);
  const [isChange, setIsChange] = useState(0);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const {
    data: downloadDetails,
    error: downloadError,
    loading: downloadLoading,
    fetchData: downloadTripDetail,
  } = useAxios<any>(`${API_ENDPOINTS.dashboard.DOWNLOAD_TRIP_DETAILS}`, 'POST', 'blob');

  const handleShareDetails = () => {
    setOpenShareModal(true);
    setAnchorEl(null);
  };
  const handleTripReconstruction = () => {
    navigate(`/trips/reconstruction/${tripId}`);
    console.log('tripid', tripId);
    // window.location.href = `/trips/reconstruction/${tripId}`;
  };

  const handleCloseModal = () => {
    setModalDateOpen(false);
  };

  const handleLive = () => {
    console.log('here');
  };

  const handleMapView = () => {
    navigate(`./../map/${tripDetailsData?.tripDetails?.tripId}`);
  };

  useEffect(() => {
    if (downloadDetails) {
      try {
        if (downloadDetails instanceof Blob) {
          const url = window.URL.createObjectURL(downloadDetails);
          const a = document.createElement('a');
          a.href = url;
          let extension = (selectedFormat || 'pdf').toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx';
          }
          const fileName = `${tripId ? `trip_${tripId}` : 'trip_details'}.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadDetails]);

  const handleDownload = () => {
    downloadTripDetail({
      fleetId: user?.customer_id,
      fileType: selectedFormat,
      tripId: tripId,
    });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };
  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, vehicleId: '' });
  const {
    data: tripDetails,
    error: tripsError,
    loading: tripsLoading,
    fetchData: fetchTripDetail,
  } = useAxios<any>(`${API_ENDPOINTS.trip.TRIP_DETAIL}`, 'POST');
  useEffect(() => {
    fetchTripDetail({ fleetId: user?.customer_id, tripId: tripId, lastEvaluatedKey: null });
  }, []);
  useEffect(() => {
    if (tripDetails?.data) {
      console.log(tripDetails?.data, 'tripDetails?.data');
      setIsChange(isChange + 1);
      setTripDetailsData(tripDetails?.data);
      console.log(tripDetails?.data, 'tripDetails?.data?.tripDetails');
      const formattedStops = tripDetails?.data?.tripDetails?.stops.map(
        (stop: { latitude: string; longitude: string }) => ({
          ...stop,
          latitude: parseFloat(stop.latitude),
          longitude: parseFloat(stop.longitude),
        }),
      );
      setStopData(formattedStops || []);
      setPollyData(tripDetails?.data?.routePaths || []);
      setCurrentStatus(
        tripStatuses.find((status) => status.value === tripDetails?.data?.tripDetails?.tripStatus),
      );
    }
  }, [tripDetails]);

  const routeData: any = useMemo(() => {
    if (tripDetails) {
      const directionsService = new google.maps.DirectionsService();

      directionsService.route(
        {
          origin: tripDetails.data.routes.sourceName,
          destination: tripDetails.data.routes.destinationName,
          travelMode: google.maps.TravelMode.DRIVING,
          provideRouteAlternatives: true,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK && result) {
            const routes = result.routes.map((route, index) => {
              console.log(route, 'route');
              return {
                routeId: btoa(`${route.summary}-${index}`).substring(0, 16),
                distance: route.legs[0].distance?.text || 'N/A',
                duration: route.legs[0].duration?.text || 'N/A',
                legs: route.legs,
                summary: route.summary || `Route ${index + 1}`,
                via: 'Direct Route',
                directions: {
                  ...result,
                  routes: [route], // wrap single route inside DirectionsResult
                },
                polylineData: route, // maintain the original route data if needed elsewhere
              };
            });
            const selectedRoutInfo = routes.find(
              (route) => tripDetails.data.routes.routeDirectionId === makeRouteKey(route),
            );
            console.log(selectedRoutInfo, 'selectedRoutInfo', tripDetails.data.routes.routeDirectionId);
            setRouteInfo(selectedRoutInfo);
            return selectedRoutInfo;
          } else {
            return null;
            console.error('Error fetching directions:', status);
          }
        },
      );
    } else {
      return null;
    }
  }, [tripDetails]);

  function makeRouteKey(route: any) {
    // 1) Summary (string)
    const summary = route.summary || '';

    // 4) Encoded overview polyline
    const poly = route.polylineData || '';

    // Combine into one string
    const fingerprint = `${summary}|${poly}`;

    // Hash it
    return md5(fingerprint);
  }

  useEffect(() => {
    let newTabs = [
      { label: 'Trip Details', component: <TripDetailTab tripDetails={tripDetailsData} /> },
      { label: 'Vehicle & Driver', component: <VehicleAndDriverTab tripDetailsData={tripDetailsData} /> },
      { label: 'Route', component: <RouteDetailsTab tripDetailsData={tripDetailsData} /> },
      {
        label: 'Alerts',
        component: <TripAlerts tripDetails={tripDetailsData?.tripDetails} isCalledFromTrip={true} />,
      },
    ];

    if (isMobile || showMap) {
      newTabs.unshift({
        label: 'Overview',
        component: <TripProgressBar showMap={showMap} isMobile={isMobile} stopsCovered={tripDetailsData} />,
      });
    }

    setTabData(newTabs);
  }, [isMobile, isChange]);

  const tripStatuses = [
    { value: 'PENDING', label: 'Requested' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'CORRUPTED', label: 'Corrupted' },
    { value: 'ONGOING', label: 'Ongoing' },
    { value: 'DEVIATED', label: 'Deviated' },
    { value: 'DELAYED', label: 'Delayed' },
    { value: 'INCOMPLETE', label: 'Incomplete' },
    { value: 'FAILED', label: 'Failed' },
  ];
  const [pollyData, setPollyData] = useState<{ lat: number; lng: number }[]>([]);
  const [stopsData, setStopData] = useState<{ index: number; lat: number; lng: number }[]>([]);
  const [value, setValue] = useState(0);
  const [currentStatus, setCurrentStatus] = useState<any>();
  const toggleMap = () => {
    setShowMap((prevShowMap) => {
      if (!prevShowMap) {
        setTabData((prevTabs: any[]) => {
          if (!prevTabs.some((tab: { label: string }) => tab.label === 'Overview')) {
            return [
              {
                label: 'Overview',
                component: (
                  <TripProgressBar
                    showMap={!prevShowMap}
                    isMobile={isMobile}
                    stopsCovered={tripDetailsData}
                  />
                ),
              },
              ...prevTabs,
            ];
          }
          return prevTabs;
        });
      } else {
        setTabData((prevTabs: any[]) =>
          prevTabs.filter((tab: { label: string }) => tab.label !== 'Overview'),
        );
      }
      return !prevShowMap;
    });
  };
  const formatDate = (date: string | null) => {
    if (!date) return '';
    const cleanedDate = date.replace(':', 'T');
    const parsedDate = new Date(cleanedDate);

    if (isNaN(parsedDate.getTime())) return '';

    const day = parsedDate.getDate();
    const month = parsedDate.toLocaleString('en-US', { month: 'short' });
    const year = parsedDate.getFullYear();

    return `${getOrdinalSuffix(day)} ${month}, ${year}`;
  };

  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return `${day}th`;
    const suffixes = ['st', 'nd', 'rd'];
    const mod = day % 10;
    return `${day}${suffixes[mod - 1] || 'th'}`;
  };
  const handleLiveFeedOpen = (vehicleId: string) => {
    setIsLiveFeedOpen({ isOpen: true, vehicleId });
  };

  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({ isOpen: false, vehicleId: '' });
  };

  const handleClone = () => {
    console.log('clone Share');

    setModalDateOpen(true);
  };
  const viewMenuData = [
    {
      name: 'Live Feed',
      icon: live,
      click: () => handleLiveFeedOpen(tripDetailsData?.tripDetails?.vehicleId),
    }, // Pass vehicleId
    { name: 'Two way communication', icon: call, click: handleLive },
    { name: 'Trip Reconstruction', icon: reverse, click: handleTripReconstruction },
    { name: 'Show on Map', icon: map, click: handleMapView },
    { name: 'Clone & createTrip', icon: clone, click: handleClone },
    { name: 'Share Trip Details', icon: share, click: handleShareDetails },
  ];
  const handleCloseShareModal = () => {
    setOpenShareModal(false);
    setAnchorEl(null);
  };

  return (
    <>
      <Paper className="w-full min-w-[320px] pt-4">
        <Box className="bg-white p-4 rounded-md shadow-md">
          <Box
            className="flex items-center gap-2 cursor-pointer text-blue-600 hover:text-blue-800"
            onClick={() => {
              // If the details page was opened with date-range params, navigate back to
              // the trips list and include them so the list can restore the same range.
              const qs = new URLSearchParams();
              if (startDateParam) qs.set('startDate', startDateParam);
              if (endDateParam) qs.set('endDate', endDateParam);
              if (selectedDurationParam) qs.set('selectedDuration', selectedDurationParam);

              const query = qs.toString();
              if (query) navigate(`/trips?${query}`);
              else navigate(-1);
            }}
          >
            <ArrowBackIcon />
            <Typography variant="body1" fontWeight={600}>
              Back
            </Typography>
          </Box>

          <Box className="flex flex-wrap justify-between items-center mt-3 gap-y-4">
            {/* Left Section */}
            <Box className="flex flex-col w-full sm:w-auto">
              <Box className="flex items-center gap-2 justify-center sm:justify-start">
                <Typography variant="h5" fontWeight={700}>
                  {tripId}
                </Typography>
                <Typography className="bg-gray-200 text-gray-800 px-3 py-1 rounded-md text-sm font-semibold">
                  {currentStatus?.label}
                </Typography>
              </Box>
              <Typography variant="body2" className="text-gray-500 text-center sm:text-left">
                Created on: {formatDate(tripDetailsData?.tripCreatedAt)}
              </Typography>
            </Box>

            {/* Right Section */}
            <Box className="grid grid-cols-2 sm:flex sm:flex-wrap items-center justify-center sm:justify-end gap-3 w-full sm:w-auto">
              {currentStatus?.value === 'COMPLETED' && (
                <Button variant="text" className="text-blue-500 font-semibold hover:bg-blue-50">
                  <KeyboardDoubleArrowLeftIcon /> &nbsp;Trip Reconstruction
                </Button>
              )}

              <Button
                variant="text"
                className="text-blue-500 font-semibold hover:bg-blue-50"
                onClick={handleShareDetails}
              >
                <ShareIcon /> &nbsp;Share
              </Button>

              <Button
                variant="text"
                onClick={handleClone}
                className="text-blue-500 font-semibold hover:bg-blue-50"
              >
                <FileCopyIcon /> &nbsp;Clone & Create Trip
              </Button>

              <Button
                variant="outlined"
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
                onClick={toggleMap}
              >
                <MapIcon /> &nbsp;{showMap ? 'Hide Map' : 'Show Map'}
              </Button>

              <CustomIconButton
                icon={<img src={download} alt="download" width={16} height={16} />}
                text="Download"
                background="transparent"
                variant="outlined"
                onClick={() => setIsDownloadModalOpen(true)}
              />

              <div className="flex justify-center sm:justify-end">
                <IconButton
                  onClick={handleClick}
                  sx={{
                    border: '1px solid rgba(44, 10, 235, 0.2)',
                    borderRadius: '8px',
                    padding: '10px',
                    width: '48px',
                    height: '48px',
                  }}
                >
                  <MoreVertIcon sx={{ color: 'blue', fontSize: '28px' }} />
                </IconButton>
                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                  {viewMenuData.map((item, index) => (
                    <MenuItem key={index} onClick={item.click}>
                      <div className="flex gap-2 mt-1">
                        <img src={item.icon} alt={item.name} className="w-5 h-5" />
                        <Typography variant="body2" fontWeight={600}>
                          {item.name}
                        </Typography>
                      </div>
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            </Box>
          </Box>

          {currentStatus?.value === 'PENDING' && (
            <Box className="mt-2 bg-gray-100 p-2 rounded-md text-gray-600">
              Waiting for the approver's confirmation. The trip can only begin once it is approved.
            </Box>
          )}
        </Box>
        {!showMap && !isMobile && (
          <Box>
            <TripProgressBar showMap={showMap} isMobile={isMobile} stopsCovered={tripDetailsData} />
          </Box>
        )}
      </Paper>
      <div className="mt-4 flex flex-col gap-4">
        <TripDetailsTiles tripDetails={tripDetailsData} />
      </div>
      {/* Tabs + Content Container */}
      <Box
        className={`relative flex flex-col md:flex-row transition-all duration-300 ${
          showMap ? 'md:h-[600px]' : ''
        }`}
      >
        {/* Tabs Section */}
        <Box className={`${showMap ? 'md:w-1/2' : 'w-full'} transition-all duration-300`}>
          {/* Scrollable Tabs */}
          <div className="w-full max-w-full overflow-x-auto whitespace-nowrap scroll-smooth border-b">
            <Tabs value={value} onChange={(e, newValue) => setValue(newValue)} className="w-max">
              {tabData?.map((tab: any, index: any) => (
                <Tab key={index} label={tab.label} />
              ))}
            </Tabs>
          </div>

          {/* Tab Panels */}
          {tabData?.map((tab: any, index: any) => (
            <div key={index} role="tabpanel" hidden={value !== index}>
              {value === index && (
                <Box className="p-4">
                  <Typography>{tab.component}</Typography>
                </Box>
              )}
            </div>
          ))}
        </Box>

        {/* Map (Desktop View) */}
        {showMap && (
          <Box className="hidden md:block w-1/2 transition-all duration-300">
            <TripDetailMap routeData={routeInfo} stopsData={stopsData} />
          </Box>
        )}
      </Box>

      {/* Map (Mobile View) - Always Visible Below Tabs */}
      {showMap && (
        <Box className="block md:hidden w-full h-[300px] mt-4 transition-all duration-300">
          <TripDetailMap routeData={routeInfo} stopsData={stopsData} />
        </Box>
      )}

      <LiveFeedModal
        trip={tripDetailsData?.tripDetails}
        open={isLiveFeedOpen.isOpen}
        onClose={handleLiveFeedClose}
      />
      <ShareModal
        open={openShareModal}
        onClose={handleCloseShareModal}
        heading="Share Details"
        subheading="Enter the recipient's email address to share the requested video details."
        shareLink={window.location.href}
        tripId={tripId || ''}
        fleetId={user?.customer_id}
        context="tripTable"
      />
      <DownloadData
        downloadLoading={downloadLoading}
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadModalClose={handleDownloadModalClose}
        selectedFormat={selectedFormat}
        handleFormatChange={handleFormatChange}
        handleDownload={handleDownload}
        modalTitle={tripId ? `Download ${tripId}` : 'Download Trip Details'}
        modalDescription="Please select a file format for your download."
        formatLabel="Format"
        formatExcelLabel="Excel"
        formatCsvLabel="CSV"
        formatPdfLabel="PDF"
        cancelButtonText="Cancel"
        downloadButtonText="Download"
      />
      <DateTimeModal open={modalDateOpen} tripId={tripId || ''} onClose={handleCloseModal} />
    </>
  );
}
